import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=64476901"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports